// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1471":"c53056c4189bf0e4","2179":"c39810a591d5e128","9487":"2902f81a83ea318a"}[chunkId] + ".css";
};